var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D213F",
    d: "M10 1.666a8.333 8.333 0 1 1 0 16.667 8.333 8.333 0 0 1 0-16.667Zm0 1.25a7.083 7.083 0 1 0 0 14.167 7.083 7.083 0 0 0 0-14.167Zm2.872 4.08.07.061c.222.222.242.57.06.814l-.06.07L10.884 10l2.058 2.058c.222.222.242.57.06.814l-.06.07a.625.625 0 0 1-.814.06l-.07-.06L10 10.883l-2.058 2.058a.625.625 0 0 1-.814.06l-.07-.06a.625.625 0 0 1-.06-.814l.06-.07L9.116 10 7.058 7.941a.625.625 0 0 1-.06-.813l.06-.07a.625.625 0 0 1 .814-.061l.07.06L10 9.115l2.058-2.058a.625.625 0 0 1 .814-.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCloseCircle);
export default __webpack_public_path__ + "static/media/Icons_Close_Circle.d292139d1ee8bf76c5a5977315a40e70.svg";
export { ForwardRef as ReactComponent };